<div class="flex flex-col">
    @if (isDisabled()) {
        <medpace-alert [content]="'Study does not support this travel option.'" [appearance]="'caution'" />
    }
    @if (!isDisabled() || (isUpdate() && formCtrl().value)) {
        <label>{{ label() }}</label>
        <mds-radio-group [formCtrl]="formCtrl()" [buttons]="radioButtons" />
    }
</div>
